import { Reducer, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
	FLUSH,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
	REHYDRATE,
	persistReducer
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { reducers } from '@/store';
import { rootReducer } from './root-reducer';
import { STORE_KEY } from './constants';

const persistConfig = {
	key: STORE_KEY,
	storage,
	// `tables` = configurațiile de coloane ale tabelelor (golite la logout din AuthProvider).
	whitelist: ['tables']
};

type TransformedReducer = Reducer<{
	[K in keyof typeof reducers]: (typeof reducers)[K] extends Reducer<infer U> ? U : never;
}>;

const reducer = persistReducer(
	persistConfig,
	rootReducer as unknown as TransformedReducer
);

export const store = configureStore({
	reducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
			}
		})
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;

setupListeners(store.dispatch);
